import type { TerminalsColumnFilterKey, TerminalsColumnFilters } from '../models/types';

export const ACCENT_COLORS = [
  '#5c6bc0',
  '#26a69a',
  '#ffa502',
  '#ff6b6b',
  '#a78bfa',
  '#2ed573',
  '#ff9f43',
];

export const SEARCH_DEBOUNCE_MS = 400;

export const EMPTY_TERMINALS_COLUMN_FILTERS: TerminalsColumnFilters = {
  merchantTerminal: null,
  acquirerTerminal: null,
  mappingId: null,
  merchantTerminalId: null,
  acquirerTerminalId: null,
  merchant: null,
  acquirer: null,
  volume: null,
  status: null,
  priority: null,
  name: null,
  country: null,
  currencies: null,
  flow: null,
  industry: null,
  traffic: null,
  notes: null,
  createdAt: null,
};

/** @deprecated Use EMPTY_TERMINALS_COLUMN_FILTERS */
export const EMPTY_MIDS_COLUMN_FILTERS = EMPTY_TERMINALS_COLUMN_FILTERS;

/** Order matches createMappingColumnDefs + audit columns (Action excluded). */
export const TERMINAL_TAB_FILTER_KEYS: TerminalsColumnFilterKey[] = [
  'merchantTerminal',
  'acquirerTerminal',
  'mappingId',
  'merchant',
  'acquirer',
  'volume',
  'status',
  'priority',
  'createdAt',
];

/** Order matches createMerchantTerminalColumnDefs + audit columns (Action excluded). */
export const MERCHANT_TERMINAL_TAB_FILTER_KEYS: TerminalsColumnFilterKey[] = [
  'merchantTerminalId',
  'name',
  'merchant',
  'country',
  'currencies',
  'flow',
  'industry',
  'traffic',
  'notes',
  'createdAt',
];

/** Order matches createAcquirerTerminalColumnDefs + audit columns (Action excluded). */
export const ACQUIRER_TERMINAL_TAB_FILTER_KEYS: TerminalsColumnFilterKey[] = [
  'acquirerTerminalId',
  'name',
  'acquirer',
  'country',
  'currencies',
  'flow',
  'industry',
  'traffic',
  'createdAt',
];

/** Labels match Ag Grid headerName values in table/columnDefs (+ audit columns). */
export const TERMINALS_COLUMN_FILTER_LABELS: Record<TerminalsColumnFilterKey, string> = {
  merchantTerminal: 'Merchant Terminal',
  acquirerTerminal: 'Acquirer Terminal',
  mappingId: 'Mapping ID',
  merchantTerminalId: 'Merchant Terminal ID',
  acquirerTerminalId: 'Acquirer Terminal ID',
  merchant: 'Merchant Name',
  acquirer: 'Acquirer Name',
  volume: 'Volume',
  status: 'Status',
  priority: 'Priority',
  name: 'Name',
  country: 'Country',
  currencies: 'Currencies',
  flow: 'Flow',
  industry: 'Industry',
  traffic: 'Traffic',
  notes: 'Notes',
  createdAt: 'Created At',
};

/** @deprecated Use TERMINALS_COLUMN_FILTER_LABELS */
export const MIDS_COLUMN_FILTER_LABELS = TERMINALS_COLUMN_FILTER_LABELS;

